export const PARCEL_ACQUISITION_DATA = [
  {
    id: '1',
    type: 'retail',
    date: '05/01/2024',
    activity: 'Sold',
    recentSalePrice: 250000,
    name: '408 Broadway, New York, NY 10013',
    lotSizeSqFt: 11362,
    lotSizeAcres: 0.261,
    yearBuilt: 1914,
    numberOfStories: 5,
    numberOfBuildings: 5,
    numberOfCommercialUnits: 1,
    recentAcquisition: 'January 2, 2012',
    mortgageAmount: 100000,
    mortgageOriginationDate: 'January 2, 2012',
    maturityDate: 'January 2, 2012',
    apn: '00196-0005',
  },
  {
    id: '2',
    type: 'retail',
    date: '06/01/2024',
    activity: 'Sold',
    recentSalePrice: 220000,
    name: '408 Broadway, New York, NY 10012',
    lotSizeSqFt: 11362,
    lotSizeAcres: 0.261,
    yearBuilt: 1914,
    numberOfStories: 5,
    numberOfBuildings: 5,
    numberOfCommercialUnits: 1,
    recentAcquisition: 'January 2, 2012',
    mortgageAmount: 100000,
    mortgageOriginationDate: 'January 2, 2012',
    maturityDate: 'January 2, 2012',
    apn: '00196-0005',
  },
  {
    id: '3',
    type: 'retail',
    date: '07/01/2024',
    activity: 'Purchased',
    recentSalePrice: 220000,
    name: '408 Broadway, New York, NY 10014',
    lotSizeSqFt: 11362,
    lotSizeAcres: 0.261,
    yearBuilt: 1914,
    numberOfStories: 5,
    numberOfBuildings: 5,
    numberOfCommercialUnits: 1,
    recentAcquisition: 'January 2, 2012',
    mortgageAmount: 100000,
    mortgageOriginationDate: 'January 2, 2012',
    maturityDate: 'January 2, 2012',
    apn: '00196-0005',
  },
  {
    id: '4',
    type: 'commercial',
    date: '08/01/2024',
    activity: 'Purchased',
    recentSalePrice: 100000,
    name: '408 Broadway, New York, NY 10011',
    lotSizeSqFt: 11362,
    lotSizeAcres: 0.261,
    yearBuilt: 1914,
    numberOfStories: 5,
    numberOfBuildings: 5,
    numberOfCommercialUnits: 1,
    recentAcquisition: 'January 2, 2012',
    mortgageAmount: 100000,
    mortgageOriginationDate: 'January 2, 2012',
    maturityDate: 'January 2, 2012',
    apn: '00196-0005',
  },
  {
    id: '5',
    type: 'land',
    date: '09/01/2021',
    activity: 'Sold',
    recentSalePrice: 2000000,
    name: '408 Broadway, New York, NY 20013',
    lotSizeSqFt: 11362,
    lotSizeAcres: 0.261,
    yearBuilt: 1914,
    numberOfStories: 5,
    numberOfBuildings: 5,
    numberOfCommercialUnits: 1,
    recentAcquisition: 'January 2, 2012',
    mortgageAmount: 100000,
    mortgageOriginationDate: 'January 2, 2012',
    maturityDate: 'January 2, 2012',
    apn: '00196-0005',
  },
  {
    id: '6',
    type: 'office',
    date: '10/01/2024',
    activity: 'Purchased',
    recentSalePrice: 320000,
    name: '408 Broadway, New York, NY 30013',
    lotSizeSqFt: 11362,
    lotSizeAcres: 0.261,
    yearBuilt: 1914,
    numberOfStories: 5,
    numberOfBuildings: 5,
    numberOfCommercialUnits: 1,
    recentAcquisition: 'January 2, 2012',
    mortgageAmount: 100000,
    mortgageOriginationDate: 'January 2, 2012',
    maturityDate: 'January 2, 2012',
    apn: '00196-0005',
  },
  {
    id: '7',
    type: 'residential',
    date: '05/01/2024',
    activity: 'Sold',
    recentSalePrice: 470000,
    name: '408 Broadway, New York, NY 10013',
    lotSizeSqFt: 11362,
    lotSizeAcres: 0.261,
    yearBuilt: 1914,
    numberOfStories: 5,
    numberOfBuildings: 5,
    numberOfCommercialUnits: 1,
    recentAcquisition: 'January 2, 2012',
    mortgageAmount: 100000,
    mortgageOriginationDate: 'January 2, 2012',
    maturityDate: 'January 2, 2012',
    apn: '00196-0005',
  },
  {
    id: '8',
    type: 'publicAmenities',
    date: '05/02/2022',
    activity: 'Sold',
    recentSalePrice: 580000,
    name: '408 Broadway, New York, NY 10013',
    lotSizeSqFt: 11362,
    lotSizeAcres: 0.261,
    yearBuilt: 1914,
    numberOfStories: 5,
    numberOfBuildings: 5,
    numberOfCommercialUnits: 1,
    recentAcquisition: 'January 2, 2012',
    mortgageAmount: 100000,
    mortgageOriginationDate: 'January 2, 2012',
    maturityDate: 'January 2, 2012',
    apn: '00196-0005',
  },
  {
    id: '9',
    type: 'single-family',
    date: '05/07/2024',
    activity: 'Purchased',
    recentSalePrice: 300000,
    name: '408 Broadway, New York, NY 10013',
    lotSizeSqFt: 11362,
    lotSizeAcres: 0.261,
    yearBuilt: 1914,
    numberOfStories: 5,
    numberOfBuildings: 5,
    numberOfCommercialUnits: 1,
    recentAcquisition: 'January 2, 2012',
    mortgageAmount: 100000,
    mortgageOriginationDate: 'January 2, 2012',
    maturityDate: 'January 2, 2012',
    apn: '00196-0005',
  },
  {
    id: '10',
    type: 'hospitality',
    date: '05/12/2024',
    activity: 'Sold',
    recentSalePrice: 5050500,
    name: '408 Broadway, New York, NY 10013',
    lotSizeSqFt: 11362,
    lotSizeAcres: 0.261,
    yearBuilt: 1914,
    numberOfStories: 5,
    numberOfBuildings: 5,
    numberOfCommercialUnits: 1,
    recentAcquisition: 'January 2, 2012',
    mortgageAmount: 100000,
    mortgageOriginationDate: 'January 2, 2012',
    maturityDate: 'January 2, 2012',
    apn: '00196-0005',
  },
  {
    id: '11',
    type: 'unassigned',
    date: '05/01/2023',
    activity: 'Sold',
    recentSalePrice: 300000,
    name: '408 Broadway, New York, NY 10013',
    lotSizeSqFt: 11362,
    lotSizeAcres: 0.261,
    yearBuilt: 1914,
    numberOfStories: 5,
    numberOfBuildings: 5,
    numberOfCommercialUnits: 1,
    recentAcquisition: 'January 2, 2012',
    mortgageAmount: 100000,
    mortgageOriginationDate: 'January 2, 2012',
    maturityDate: 'January 2, 2012',
    apn: '00196-0005',
  },
  {
    id: '12',
    type: 'unassigned',
    date: '05/01/2023',
    activity: 'Sold',
    recentSalePrice: 300000,
    name: '408 Broadway, New York, NY 70013',
    lotSizeSqFt: 11362,
    lotSizeAcres: 0.261,
    yearBuilt: 1914,
    numberOfStories: 5,
    numberOfBuildings: 5,
    numberOfCommercialUnits: 1,
    recentAcquisition: 'January 2, 2012',
    mortgageAmount: 100000,
    mortgageOriginationDate: 'January 2, 2012',
    maturityDate: 'January 2, 2012',
    apn: '00196-0005',
  },
  {
    id: '13',
    type: 'unassigned',
    date: '05/01/2023',
    activity: 'Purchased',
    recentSalePrice: 300000,
    name: '408 Broadway, New York, NY 42013',
    lotSizeSqFt: 11362,
    lotSizeAcres: 0.261,
    yearBuilt: 1914,
    numberOfStories: 5,
    numberOfBuildings: 5,
    numberOfCommercialUnits: 1,
    recentAcquisition: 'January 2, 2012',
    mortgageAmount: 100000,
    mortgageOriginationDate: 'January 2, 2012',
    maturityDate: 'January 2, 2012',
    apn: '00196-0005',
  },
]
